import { render } from "./CollectionGateSuccess.vue?vue&type=template&id=e7fe23ee&scoped=true"
import script from "./CollectionGateSuccess.vue?vue&type=script&lang=js"
export * from "./CollectionGateSuccess.vue?vue&type=script&lang=js"

import "./CollectionGateSuccess.vue?vue&type=style&index=0&id=e7fe23ee&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7fe23ee"]])

export default __exports__